import React from "react";
import { Outlet } from "react-router-dom";

import { Header } from "../Header";
import { PreventBackButton } from "../functional";
import { useGtagView } from "src/hooks/useGtagView";

export function ConfirmBookingBookingLayout({ children }: React.PropsWithChildren) {
    useGtagView();

    return <div className='bg-gray-50 flex flex-col min-h-dvh pb-[env(safe-area-inset-bottom, 0)]'>
        <Header hideCloseButton progressBar />
        <div className="relative">
            <main className='max-w-lg mx-auto px-5 pt-12 pb-4 lg:pb-12 flex flex-1 flex-col'>
                <Outlet />
                {children}
            </main>
        </div>
        <PreventBackButton />
    </div>
}